import React, { useEffect, useState } from 'react';
import {
    Typography,
    Box,
    CssBaseline,
    Tabs,
    Tab,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    TextField,
    Modal,
    MenuItem,
    InputAdornment,
    IconButton,
} from '@mui/material';
import {
    AccessTime,
    EditNote,
    Key,
    Cancel,
    Visibility, 
    VisibilityOff,
    } from '@mui/icons-material';
    import axios from 'axios';
    import { global_link } from '../Components/Globallink';
    import modalStyle from '../Components/ModalStyle';

const Settings = () => {
    const [activeTab, setActiveTab] = useState(0);

    const api = axios.create({baseURL: global_link});
    const authToken = process.env.AUTH_TOKEN;

    const [totalItems, setTotalItems] = useState(0);
    const [totalServerItems, setTotalServerItems] = useState(0);
    const [totalUserItems, setTotalUserItems] = useState(0);
    const [totalSmsItems, setTotalSmsItems] = useState(0);
    const [totalEmailItems, setTotalEmailItems] = useState(0);
    const [totalWhatsappItems, setTotalWhatsappItems] = useState(0);
    const [totalTwitterItems, setTotalTwitterItems] = useState(0);
    const [totalFacebookItems, setTotalFacebookItems] = useState(0);
    const [totalInstagramItems, setTotalInstagramItems] = useState(0);
    const [totalCallItems, setTotalCallItems] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const [organizationData, setOrganizationData] = useState([]);
    const [serverData, setServerData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [smsData, setSmsData] = useState([]);
    const [emailSettingsData, setEmailSettingsData] = useState([]);
    const [whatsAppData, setWhatsAppData] = useState([]);
    const [twitterData, setTwitterData] = useState([]);
    const [facebookData, setFacebookData] = useState([]);
    const [instagramData, setInstagramData] = useState([]);
    const [callData, setCallData] = useState([]);
    const [addOrganizationModal, setAddOrganizationModal] = useState(false);
    const [editOrganizationModal, setEditOrganizationModal] = useState(false);
    const [addServerModal, setAddServerModal] = useState(false);
    const [editServerModal, setEditServerModal] = useState(false);
    const [addUserModal, setAddUserModal] = useState(false);
    const [editUserModal, setEditUserModal] = useState(false);
    const [addSmsModal, setAddSmsModal] = useState(false);
    const [editSmsModal, setEditSmsModal] = useState(false);
    const [addEmailModal, setAddEmailModal] = useState(false);
    const [editEmailModal, setEditEmailModal] = useState(false);
    const [addWhatsappModal, setAddWhatsappModal] = useState(false);
    const [editWhatsappModal, setEditWhatsappModal] = useState(false);
    const [editUserPasswordModal, setEditUserPasswordModal] = useState(false);

    const [selectedItem, setSelectedItem] = useState('');


    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
      };
      
      const handleMouseDownPassword = (event) => {
        event.preventDefault();
      };


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
      };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // TABLE ONE
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // TABLE TWO
    const [serverpage, setServerPage] = useState(0);
    const [serverrowsPerPage, setServerRowsPerPage] = useState(10);

    // TABLE THREE
    const [userpage, setUserPage] = useState(0);
    const [userrowsPerPage, setUserRowsPerPage] = useState(10);

    // TABLE FOUR
    const [smspage, setSmsPage] = useState(0);
    const [smsrowsPerPage, setSmsRowsPerPage] = useState(10);

    // TABLE FIVE
    const [emailContactpage, setEmailContactPage] = useState(0);
    const [emailContactrowsPerPage, setEmailContactRowsPerPage] = useState(10);

    // TABLE SIX
    const [whatsapppage, setWhatsAppPage] = useState(0);
    const [whatsapprowsPerPage, setWhatsAppRowsPerPage] = useState(10);

    // TABLE SEVEN
    const [twitterpage, setTwitterPage] = useState(0);
    const [twitterPerPage, setTwitterRowsPerPage] = useState(10);

    // TABLE EIGHT
    const [facebookpage, setFacebookPage] = useState(0);
    const [facebookrowsPerPage, setFacebookRowsPerPage] = useState(10);

    // TABLE NINE
    const [instagrampage, setInstagramPage] = useState(0);
    const [instagramrowsPerPage, setInstagramRowsPerPage] = useState(10);

    // TABLE TEN
    const [callpage, setCallPage] = useState(0);
    const [callrowsPerPage, setCallRowsPerPage] = useState(10);


    // TABLE TWO
    const handleServerChangePage = (event, newPage) => {
        setServerPage(newPage);
    };
    const handleServerChangeRowsPerPage = (event) => {
        setServerRowsPerPage(parseInt(event.target.value, 10));
        setServerPage(0); // Reset to first page
    };

    // TABLE THREE
    const handleUserChangePage = (event, newPage) => {
        setUserPage(newPage);
    };
    const handleUserChangeRowsPerPage = (event) => {
        setUserRowsPerPage(parseInt(event.target.value, 10));
        setUserPage(0); // Reset to first page
    };

    // TABLE FOUR
    const handleSmsChangePage = (event, newPage) => {
        setSmsPage(newPage);
    };
    const handleSmsChangeRowsPerPage = (event) => {
        setSmsRowsPerPage(parseInt(event.target.value, 10));
        setSmsPage(0); // Reset to first page
    };

    // TABLE FIVE
    const handleEmailContactChangePage = (event, newPage) => {
        setEmailContactPage(newPage);
    };
    const handleEmailContactChangeRowsPerPage = (event) => {
        setEmailContactRowsPerPage(parseInt(event.target.value, 10));
        setEmailContactPage(0); // Reset to first page
    };

    // TABLE SIX
    const handleWhatsAppChangePage = (event, newPage) => {
        setWhatsAppPage(newPage);
    };
    const handleWhatsAppChangeRowsPerPage = (event) => {
        setWhatsAppRowsPerPage(parseInt(event.target.value, 10));
        setWhatsAppPage(0); // Reset to first page
    };

    // TABLE SEVEN
    const handleTwitterChangePage = (event, newPage) => {
        setTwitterPage(newPage);
    };
    const handleTwitterChangeRowsPerPage = (event) => {
        setTwitterRowsPerPage(parseInt(event.target.value, 10));
        setTwitterPage(0); // Reset to first page
    };

    // TABLE EIGHT
    const handleFacebookChangePage = (event, newPage) => {
        setFacebookPage(newPage);
    };
    const handleFacebookChangeRowsPerPage = (event) => {
        setFacebookRowsPerPage(parseInt(event.target.value, 10));
        setFacebookPage(0); // Reset to first page
    };

    // TABLE NINE
    const handleInstagramChangePage = (event, newPage) => {
        setInstagramPage(newPage);
    };
    const handleInstagramChangeRowsPerPage = (event) => {
        setInstagramRowsPerPage(parseInt(event.target.value, 10));
        setInstagramPage(0); // Reset to first page
    };

    // TABLE TEN
    const handleCallChangePage = (event, newPage) => {
        setCallPage(newPage);
    };
    const handleCallChangeRowsPerPage = (event) => {
        setCallRowsPerPage(parseInt(event.target.value, 10));
        setCallPage(0); // Reset to first page
    };


      // TABLE ONE: Organization Table
      const fetchOrganizationData = async () => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get('/organization/all', {
                params: {
                    search: searchTerm,
                    limit: rowsPerPage,
                    offset: page * rowsPerPage,
                },
                headers: {
                    Authorization: `Bearer ${authyToken}`,
                },
            });
            setOrganizationData(response.data.data);
            setTotalItems(response.data.total);
        } catch (error) {
            console.error('Error fetching Server Data:', error);
        }
    };
    


      // TABLE TWO: Server Table
const fetchServerData = async () => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/server/all', {
            params: {
                search: searchTerm,
                limit: serverrowsPerPage,
                offset: serverpage * serverrowsPerPage,
            },
            headers: {
                Authorization: `Bearer ${authyToken}`,
            },
        });
        setServerData(response.data.data);
        setTotalServerItems(response.data.total);
    } catch (error) {
        console.error('Error fetching Server Data:', error);
    }
};

// TABLE THREE: User Table
const fetchUserData = async () => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/user/getuserssupadmin', {
            params: {
                search: searchTerm,
                limit: userrowsPerPage,
                offset: userpage * userrowsPerPage,
            },
            headers: {
                Authorization: `Bearer ${authyToken}`,
            },
        });
        setUserData(response.data.data);
        setTotalUserItems(response.data.total);
    } catch (error) {
        console.error('Error fetching User Data:', error);
    }
};

// TABLE FOUR: SMS Table
const fetchSmsData = async () => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('sms/getadminsmssettings', {
            params: {
                search: searchTerm,
                limit: smsrowsPerPage,
                offset: smspage * smsrowsPerPage,
            },
            headers: {
                Authorization: `Bearer ${authyToken}`,
            },
        });
        setSmsData(response.data.data);
        setTotalSmsItems(response.data.total);
    } catch (error) {
        console.error('Error fetching SMS Data:', error);
    }
};

// TABLE FIVE: Email Contact Table
const fetchEmailSettingsData = async () => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/email/emailsettingsadmin', {
            params: {
                search: searchTerm,
                limit: emailContactrowsPerPage,
                offset: emailContactpage * emailContactrowsPerPage,
            },
            headers: {
                Authorization: `Bearer ${authyToken}`,
            },
        });
        setEmailSettingsData(response.data.data);
        setTotalEmailItems(response.data.total);
    } catch (error) {
        console.error('Error fetching Email Contact Data:', error);
    }
};

// TABLE SIX: WhatsApp Table
const fetchWhatsAppData = async () => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/whatsapp/getconfigsadmin', {
            params: {
                search: searchTerm,
                limit: whatsapprowsPerPage,
                offset: whatsapppage * whatsapprowsPerPage,
            },
            headers: {
                Authorization: `Bearer ${authyToken}`,
            },
        });
        setWhatsAppData(response.data.data);
        setTotalWhatsappItems(response.data.total);
    } catch (error) {
        console.error('Error fetching WhatsApp Data:', error);
    }
};

// TABLE SEVEN: Twitter Table
const fetchTwitterData = async () => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/twitter/all', {
            params: {
                search: searchTerm,
                limit: twitterPerPage,
                offset: twitterpage * twitterPerPage,
            },
            headers: {
                Authorization: `Bearer ${authyToken}`,
            },
        });
        setTwitterData(response.data.data);
        setTotalTwitterItems(response.data.total);
    } catch (error) {
        console.error('Error fetching Twitter Data:', error);
    }
};

// TABLE EIGHT: Facebook Table
const fetchFacebookData = async () => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/facebook/all', {
            params: {
                search: searchTerm,
                limit: facebookrowsPerPage,
                offset: facebookpage * facebookrowsPerPage,
            },
            headers: {
                Authorization: `Bearer ${authyToken}`,
            },
        });
        setFacebookData(response.data.data);
        setTotalFacebookItems(response.data.total);
    } catch (error) {
        console.error('Error fetching Facebook Data:', error);
    }
};

// TABLE NINE: Instagram Table
const fetchInstagramData = async () => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/instagram/all', {
            params: {
                search: searchTerm,
                limit: instagramrowsPerPage,
                offset: instagrampage * instagramrowsPerPage,
            },
            headers: {
                Authorization: `Bearer ${authyToken}`,
            },
        });
        setInstagramData(response.data.data);
        setTotalInstagramItems(response.data.total);
    } catch (error) {
        console.error('Error fetching Instagram Data:', error);
    }
};

// TABLE TEN: Call Table
const fetchCallData = async () => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/call/all', {
            params: {
                search: searchTerm,
                limit: callrowsPerPage,
                offset: callpage * callrowsPerPage,
            },
            headers: {
                Authorization: `Bearer ${authyToken}`,
            },
        });
        setCallData(response.data.data);
        setTotalCallItems(response.data.total);
    } catch (error) {
        console.error('Error fetching Call Data:', error);
    }
};

const handleInputChange = (event) => {
    const { name, value } = event.target;
};

const handleAddOrganizationSubmit = (event) =>{
      event.preventDefault();
      const formData = new FormData(event.target);
      const authyToken = localStorage.getItem(authToken);
      const headers = {
          Authorization: `Bearer ${authyToken}`,
          "Content-Type": "application/json",
      };
      api.post('/organization/add', formData,{ headers, withCredentials: true})
        .then((response) => {
            handleCloseAddOrganizationModal();
            fetchOrganizationData();
        }).catch((error) => {console.error(error);});
}

const handleEditOrganizationSubmit = (event) =>{
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.put('/organization/edit', formData,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditOrganizationModal();
        fetchOrganizationData();
      }).catch((error) => {console.error(error);});
}

const handleDeleteOrganization = (organization_id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.delete(`/organization/delete/${organization_id}`,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditOrganizationModal();
        fetchOrganizationData();
      }).catch((error) => {console.error(error);});
}



const handleOpenAddOrganizationModal = () => {
    setAddOrganizationModal(true);
};

const handleCloseAddOrganizationModal = () => {
    setAddOrganizationModal(false);
};


const handleOpenEditOrganizationModal = (item) => {
    setEditOrganizationModal(true);
    setSelectedItem(item);
};

const handleCloseEditOrganizationModal = () => {
    setEditOrganizationModal(false);
};

// Server Handlers
const handleAddServerSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.post('/server/add', formData,{ headers, withCredentials: true})
      .then((response) => {
          handleCloseAddServerModal();
          fetchServerData();
      }).catch((error) => {console.error(error);});
};

const handleEditServerSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.put('/server/edit', formData,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditServerModal();
        fetchServerData();
      }).catch((error) => {console.error(error);});
};

const handleDeleteServer = (server_id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.delete(`/server/delete/${server_id}`,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditServerModal();
        fetchServerData();
      }).catch((error) => {console.error(error);});
}

const handleOpenAddServerModal = () => {
    setAddServerModal(true);
};

const handleCloseAddServerModal = () => {
    setAddServerModal(false);
};

const handleOpenEditServerModal = (item) => {
    setEditServerModal(true);
    setSelectedItem(item);
};

const handleCloseEditServerModal = () => {
    setEditServerModal(false);
};


// Users Handlers
const handleAddUserSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.post('/user/addusersuperadmin', formData,{ headers, withCredentials: true})
      .then((response) => {
          handleCloseAddUserModal();
          fetchUserData();
      }).catch((error) => {console.error(error);});
};

const handleEditUserSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.put('/user/editusersuperadmin', formData,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditUserModal();
        fetchUserData();
      }).catch((error) => {console.error(error);});
};

const handleDeleteUser = (user_id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.delete(`/user/deleteuseradmin/${user_id}`,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditUserModal();
        fetchUserData();
      }).catch((error) => {console.error(error);});
}

const handleOpenAddUserModal = () => {
    setAddUserModal(true);
};

const handleCloseAddUserModal = () => {
    setAddUserModal(false);
};

const handleOpenEditUserModal = (item) => {
    setEditUserModal(true);
    setSelectedItem(item);
};

const handleCloseEditUserModal = () => {
    setEditUserModal(false);
};


// User Password Update

const handleEditUserPasswordSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.put('/user/userpasssettingsupdate', formData,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditUserPasswordModal();
        fetchUserData();
      }).catch((error) => {console.error(error);});
};

const handleOpenEditUserPasswordModal = (item) => {
    setEditUserPasswordModal(true);
    setSelectedItem(item);
};

const handleCloseEditUserPasswordModal = () => {
    setEditUserPasswordModal(false);
};


// SMS Handlers
const handleAddSmsSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.post('/sms/addsettings', formData,{ headers, withCredentials: true})
      .then((response) => {
          handleCloseAddSmsModal();
          fetchSmsData();
      }).catch((error) => {console.error(error);});
};

const handleEditSmsSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.put('/sms/editsmssettings', formData,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditSmsModal();
        fetchSmsData();
      }).catch((error) => {console.error(error);});
};

const handleDeleteSmsSettings = (id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.delete(`/sms/deletesmssettings/${id}`,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditSmsModal();
        fetchSmsData();
      }).catch((error) => {console.error(error);});
}

const handleOpenAddSmsModal = () => {
    setAddSmsModal(true);
};

const handleCloseAddSmsModal = () => {
    setAddSmsModal(false);
};

const handleOpenEditSmsModal = (item) => {
    setEditSmsModal(true);
    setSelectedItem(item);
};

const handleCloseEditSmsModal = () => {
    setEditSmsModal(false);
};


// Email Handlers
const handleAddEmailSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.post('/email/addsettings', formData,{ headers, withCredentials: true})
      .then((response) => {
          handleCloseAddEmailModal();
          fetchEmailSettingsData();
      }).catch((error) => {console.error(error);});
};

const handleEditEmailSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.put('/email/editsettings', formData,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditEmailModal();
        fetchEmailSettingsData();
      }).catch((error) => {console.error(error);});
};

const handleDeleteEmailSettings = (mail_id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.delete(`/email/deletesettings/${mail_id}`,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditEmailModal();
        fetchEmailSettingsData();
      }).catch((error) => {console.error(error);});
}

const handleOpenAddEmailModal = () => {
    setAddEmailModal(true);
};

const handleCloseAddEmailModal = (item) => {
    setAddEmailModal(false);
};

const handleOpenEditEmailModal = (item) => {
    setEditEmailModal(true);
    setSelectedItem(item);
};

const handleCloseEditEmailModal = () => {
    setEditEmailModal(false);
};


// WhatsApp Handlers
const handleAddWhatsappSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.post('/whatsapp/addconfigs', formData,{ headers, withCredentials: true})
      .then((response) => {
          handleCloseAddWhatsappModal();
          fetchWhatsAppData();
      }).catch((error) => {console.error(error);});
};

const handleEditWhatsappSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.put('/whatsapp/editconfigs', formData,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditWhatsappModal();
        fetchWhatsAppData();
      }).catch((error) => {console.error(error);});
};

const handleDeleteWhatsappConfigs = (unique_id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    api.delete(`/whatsapp/deleteconfigs/${unique_id}`,{ headers, withCredentials: true})
      .then((response) => {
        handleCloseEditWhatsappModal();
        fetchWhatsAppData();
      }).catch((error) => {console.error(error);});
}

const handleOpenAddWhatsappModal = () => {
    setAddWhatsappModal(true);
};

const handleCloseAddWhatsappModal = () => {
    setAddWhatsappModal(false);
};

const handleOpenEditWhatsappModal = (item) => {
    setEditWhatsappModal(true);
    setSelectedItem(item);
};

const handleCloseEditWhatsappModal = () => {
    setEditWhatsappModal(false);
};

const handleInputModChange = (event) => {
    const { name, value } = event.target;
    setSelectedItem((prevFormState) => ({
      ...prevFormState,
      [name]: value,
    }));
  };

      useEffect(() => {
        fetchOrganizationData();
        fetchUserData();
        fetchServerData();
        fetchSmsData();
        fetchEmailSettingsData();
        fetchWhatsAppData();
      }, [searchTerm, page, rowsPerPage]);
    return (
<>
<CssBaseline />
    <Typography variant='h5' sx={{marginBottom:'15px'}}>
        Settings
    </Typography>
            <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
                <Box
                    sx={{bgcolor:'background.paper',boxShadow: 'none', border: `0.1px solid rgba(207, 211, 212, 0.2)`, borderRadius: '5px'}}
                >
                                   <Tabs
  value={activeTab}
  onChange={handleTabChange}
  variant="fullWidth"
   aria-label="Profile Tabs"
   sx={{padding:'2px',}}
      >
        <Tab label="Organization"/>
        <Tab  label="Server"/>
        <Tab  label="Users"/>
        <Tab  label="SMS"/>
        <Tab  label="Email"/>
        <Tab  label="WhatsApp"/>
        <Tab  label="Twiter"/>
        <Tab  label="Facebook"/>
        <Tab  label="Instagram"/>
        <Tab  label="Call"/>
      </Tabs>
            {activeTab === 0 && (                                
                
                <Box>
                                <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
        <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search"
        />

            <Button
            variant="contained"
            fullWidth
            type="submit"
            color='info'
            sx={{padding:'10px', }}
            onClick={handleOpenAddOrganizationModal}>
            Add Organization
            </Button>

        </Box>
                    <TableContainer>
                                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                                        {/* Table Head */}
                                        <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                                            <TableRow>
                                                <TableCell>Organization</TableCell>
                                                <TableCell>Email</TableCell>
                                                <TableCell>Phone Number</TableCell>
                                                <TableCell>Members (Cap)</TableCell>
                                                <TableCell>Current Members</TableCell>
                                                <TableCell>Recurrent Cost (KES)</TableCell>
                                                <TableCell>Expiry</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {organizationData
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{row.organization_name}</TableCell>
                                                        <TableCell>{row.organization_email}</TableCell>
                                                        <TableCell>{row.organization_phone}</TableCell>
                                                        <TableCell>{row.organization_members}</TableCell>
                                                        <TableCell>{row.user_count}</TableCell>
                                                        <TableCell>{(parseFloat(row.recurrent_cost)).toLocaleString('en-US')}</TableCell>
                                                        <TableCell>{row.due_date}</TableCell>
                                                        <TableCell><Button variant="contained" color="warning" sx={{padding:'1px',margin:'5px'}} onClick={ () => handleOpenEditOrganizationModal(row)}><EditNote sx={{fontSize:'1.5rem', cursor:'pointer', margin:'5px'}}/></Button></TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    component="div"
                                    count={totalItems}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    rowsPerPageOptions={[10, 50, 100]}
                                />
                                



            <Modal
                open={addOrganizationModal}
                onClose={handleCloseAddOrganizationModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={modalStyle}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3 id="modal-title">New Organization</h3>
                        <Box display="flex" justifyContent="right">
                            <Cancel onClick={handleCloseAddOrganizationModal} sx={{ cursor: 'pointer' }} />
                        </Box>
                    </Box>
                    <form onSubmit={handleAddOrganizationSubmit}>
          <Grid container spacing={1}>

            <Grid item xs={6}>

            <TextField
            label="Organization Name"
            name="organization_name"
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            required="true"
            sx={{marginTop:"5px"}}
            />
            </Grid>

        <Grid item xs={6}>
        <TextField
        label="Organization Email"
        name="organization_email"
        onChange={handleInputChange}
        fullWidth
        variant="outlined"
        required="true"
        sx={{marginTop:"5px"}}
        />
        </Grid>

        <Grid item xs={6}>
        <TextField
        label="Organization Phone Number"
        name="organization_phone"
        onChange={handleInputChange}
        fullWidth
        variant="outlined"
        required="true"
        sx={{marginTop:"5px"}}
        />
        </Grid>

        <Grid item xs={6}>
        <TextField
        label="Organization Members"
        onChange={handleInputChange}
        name="organization_members"
        fullWidth
        variant="outlined"
        required="true"
        type='number'
        sx={{marginTop:"5px"}}
        />
        </Grid>


        <Grid item xs={6}>
        <TextField
        fullWidth
        select
        label="Organization Plan"
        sx={{marginTop:"5px"}}
        onChange={handleInputChange}
        name="organization_plan"
        required="true"
      >
        <MenuItem value="" disabled>Select Plan</MenuItem>
        <MenuItem value="basic">Basic</MenuItem>
        <MenuItem value="standard">Standard</MenuItem>
        <MenuItem value="enterprise">Enterprise</MenuItem>
      </TextField>
        </Grid>

        <Grid item xs={6}>
        <TextField
        label="Organization Pass Phrase"
        name="organization_pass_prefix"
        onChange={handleInputChange}
        fullWidth
        variant="outlined"
        required="true"
        sx={{marginTop:"5px"}}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        </Grid>

        
        <Grid item xs={6}>
        <TextField
        label="Recurrent Cost"
        onChange={handleInputChange}
        name="recurrent_cost"
        fullWidth
        variant="outlined"
        required="true"
        sx={{marginTop:"5px"}}
        />
        </Grid>

        <Grid item xs={6}>
        <TextField
        name="due_date"
        onChange={handleInputChange}
        fullWidth
        variant="outlined"
        required="true"
        type="date"
        InputProps={{
            inputProps: {
              min: new Date().toISOString().split('T')[0], // Set the minimum date to today
            },
          }}
        sx={{marginTop:"5px"}}
        />
        </Grid>

<Grid item xs={12}>
<Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Add Organization</Button>
</Grid>

            </Grid>
          </form>
                </Box>
            </Modal>       






            <Modal
                open={editOrganizationModal}
                onClose={handleCloseEditOrganizationModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={modalStyle}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3 id="modal-title">Edit Organization | {selectedItem && (selectedItem.organization_name)}</h3>
                        <Box display="flex" justifyContent="right">
                            <Cancel onClick={handleCloseEditOrganizationModal} sx={{ cursor: 'pointer' }} />
                        </Box>
                    </Box>
                    <form onSubmit={handleEditOrganizationSubmit}>
          <Grid container spacing={1}>

            <Grid item xs={6}>

            <TextField
            label="Organization ID"
            name="organization_id"
            onChange={handleInputModChange}
            fullWidth
            variant="outlined"
            required="true"
            sx={{marginTop:"5px",display:'none!important'}}
            value={selectedItem.organization_id || ''}
            />

            <TextField
            label="Organization Name"
            name="organization_name"
            onChange={handleInputModChange}
            fullWidth
            variant="outlined"
            required="true"
            sx={{marginTop:"5px"}}
            value={selectedItem.organization_name || ''}
            />
            </Grid>

        <Grid item xs={6}>
        <TextField
        label="Organization Email"
        name="organization_email"
        onChange={handleInputModChange}
        fullWidth
        variant="outlined"
        required="true"
        sx={{marginTop:"5px"}}
        value={selectedItem.organization_email || ''}
        />
        </Grid>

        <Grid item xs={6}>
        <TextField
        label="Organization Phone Number"
        name="organization_phone"
        onChange={handleInputModChange}
        fullWidth
        variant="outlined"
        required="true"
        sx={{marginTop:"5px"}}
        value={selectedItem.organization_phone || ''}
        />
        </Grid>

        <Grid item xs={6}>
        <TextField
        label="Organization Members"
        name="organization_members"
        onChange={handleInputModChange}
        fullWidth
        variant="outlined"
        required="true"
        type='number'
        sx={{marginTop:"5px"}}
        value={selectedItem.organization_members || ''}
        />
        </Grid>


        <Grid item xs={6}>
        <TextField
        fullWidth
        select
        label="Organization Plan"
        name="organization_plan"
        sx={{marginTop:"5px"}}
        onChange={handleInputModChange}
        required="true"
        value={selectedItem.organization_plan || ''}
      >
        <MenuItem value="" disabled>Select Plan</MenuItem>
        <MenuItem value="basic">Basic</MenuItem>
        <MenuItem value="standard">Standard</MenuItem>
        <MenuItem value="enterprise">Enterprise</MenuItem>
      </TextField>
        </Grid>

        <Grid item xs={6}>
        <TextField
        label="Organization Pass Phrase"
        name="organization_pass_prefix"
        onChange={handleInputModChange}
        fullWidth
        variant="outlined"
        required="true"
        sx={{marginTop:"5px"}}
        value={selectedItem.organization_pass_prefix || ''}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        </Grid>

        <Grid item xs={6}>
        <TextField
        label="Organization Recurrent Cost"
        name="recurrent_cost"
        onChange={handleInputModChange}
        fullWidth
        variant="outlined"
        required="true"
        value={selectedItem.recurrent_cost || ''}
        sx={{marginTop:"5px"}}
        />
        </Grid>

        <Grid item xs={6}>
        <TextField
        name="due_date"
        onChange={handleInputModChange}
        fullWidth
        variant="outlined"
        required="true"
        type="date"
        value={selectedItem.due_date || ''}
        sx={{marginTop:"5px"}}
        />
        </Grid>


        <Grid item xs={12}>
        <TextField
        fullWidth
        select
        label="Organization Status"
        name="active"
        sx={{marginTop:"5px"}}
        onChange={handleInputModChange}
        required="true"
        value={selectedItem.active || ''}
      >
        <MenuItem value="" disabled>Select Status</MenuItem>
        <MenuItem value="1">Active</MenuItem>
        <MenuItem value="0">Inactive</MenuItem>
      </TextField>
        </Grid>


<Grid item xs={6}>
<Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Edit Organization</Button>
</Grid>

<Grid item xs={6}>
<Button type="button" variant="contained" color='error' sx={{padding:"10px",marginTop:"10px",width:"100%"}} onClick={()=>handleDeleteOrganization(selectedItem.organization_id)}>Delete Organization</Button>
</Grid>

            </Grid>
          </form>
                </Box>
            </Modal>                              
                                
                                
                                
                                
                                </Box>)}
            {activeTab === 1 && (<Box>
                <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
                <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search"
        />
            <Button
    variant="contained"
    fullWidth
    type="submit"
    color='info'
    sx={{padding:'10px', }}
    onClick={handleOpenAddServerModal}
  >Add Server
    </Button>

        </Box>
                    <TableContainer>
                                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                                        {/* Table Head */}
                                        <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                                            <TableRow>
                                                <TableCell>Organization</TableCell>
                                                <TableCell>Name</TableCell>
                                                <TableCell>URL / IP</TableCell>
                                                <TableCell>Port</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Voice Server</TableCell>
                                                <TableCell>Date</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {serverData
                                            .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{row.organization_name}</TableCell>
                                                        <TableCell>{row.server_name}</TableCell>
                                                        <TableCell>{row.server_url}</TableCell>
                                                        <TableCell>{row.server_port}</TableCell>
                                                        <TableCell>{row.server_active === 1 ? 'Active' : 'Inactive'}</TableCell>
                                                        <TableCell>{row.server_voice_url}</TableCell>
                                                        <TableCell>{row.server_date}</TableCell>
                                                        <TableCell><Button variant="contained" color="warning" sx={{padding:'1px',margin:'5px'}} onClick={ () => handleOpenEditServerModal(row)}><EditNote sx={{fontSize:'1.5rem', cursor:'pointer', margin:'5px'}}/></Button></TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                            rowsPerPageOptions={[10, 50, 100]}
                            component="div"
                            count={totalServerItems} // Replace with the total number of items for the table
                            rowsPerPage={serverrowsPerPage}
                            page={serverpage}
                            onPageChange={handleServerChangePage}
                            onRowsPerPageChange={handleServerChangeRowsPerPage}
                        />
                        
                        <Modal
    open={addServerModal}
    onClose={handleCloseAddServerModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">New Server</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseAddServerModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleAddServerSubmit}>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <TextField
                            fullWidth
                            select
                            label="Organization Name"
                            name="organization_id"
                            sx={{marginTop:"5px"}}
                            onChange={handleInputChange}
                            required="true"
                          >
                            <MenuItem value="" selected disabled>Select Organization</MenuItem>
                                  {organizationData.map((organization, i) => (
                                      <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                                  ))}
                          </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Server Name"
                        name="server_name"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Server URL"
                        name="server_url"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Server Port"
                        name="server_port"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        select
                        label="Server Active"
                        name="server_active"
                        sx={{marginTop:"5px"}}
                        onChange={handleInputChange}
                        required={true}
                    >
                        <MenuItem value="1">Active</MenuItem>
                        <MenuItem value="0">Inactive</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Server Voice URL"
                        name="server_voice_url"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Add Server</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>

<Modal
    open={editServerModal}
    onClose={handleCloseEditServerModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">Edit Server | {selectedItem && (selectedItem.server_name)}</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseEditServerModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleEditServerSubmit}>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <TextField
                            fullWidth
                            select
                            label="Organization Name"
                            name="organization_id"
                            sx={{marginTop:"5px"}}
                            value={selectedItem.organization_id || ''}
                            onChange={handleInputModChange}
                            required="true"
                          >
                            <MenuItem value="" selected disabled>Select Organization</MenuItem>
                                  {organizationData.map((organization, i) => (
                                      <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                                  ))}
                          </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Server Name"
                        name="server_name"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.server_name || ''}
                    />
                    <TextField
                        label="Server ID"
                        name="server_id"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px",display:'none!important'}}
                        value={selectedItem.server_id || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Server URL"
                        name="server_url"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.server_url || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Server Port"
                        name="server_port"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.server_port || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        select
                        label="Server Active"
                        name="server_active"
                        sx={{marginTop:"5px"}}
                        onChange={handleInputModChange}
                        value={selectedItem.server_active || ''}
                        required={true}
                    >
                        <MenuItem value="1">Active</MenuItem>
                        <MenuItem value="0">Inactive</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Server Voice URL"
                        name="server_voice_url"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        sx={{marginTop:"5px"}}
                        value={selectedItem.server_voice_url|| ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Edit Server</Button>
                </Grid>

                <Grid item xs={6}>
                    <Button type="button" variant="contained" color='error' sx={{padding:"10px",marginTop:"10px",width:"100%"}} onClick={()=>handleDeleteServer(selectedItem.server_id)}>Delete Server</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>                      
                        
                        
                        
                        </Box>)}
            {activeTab === 2 && (<Box>
                <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
                <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search"
        />
            <Button
    variant="contained"
    fullWidth
    type="submit"
    color='info'
    sx={{padding:'10px', }}
    onClick={handleOpenAddUserModal}
  >Add User
    </Button>

        </Box>
                    <TableContainer>
                                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                                        {/* Table Head */}
                                        <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                                            <TableRow>
                                                <TableCell>Organization</TableCell>
                                                <TableCell>Name</TableCell>
                                                <TableCell>Extension</TableCell>
                                                <TableCell>Email</TableCell>
                                                <TableCell>Role</TableCell>
                                                <TableCell>Reg Date</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {userData
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{row.organization_name}</TableCell>
                                                        <TableCell>{row.user_name}</TableCell>
                                                        <TableCell>{row.user_extension}</TableCell>
                                                        <TableCell>{row.user_email}</TableCell>
                                                        <TableCell>{row.user_level}</TableCell>
                                                        <TableCell>{row.user_reg_date}</TableCell>
                                                        <TableCell><Button variant="contained" color="info" sx={{padding:'1px',margin:'5px'}} onClick={ () => handleOpenEditUserModal(row)} ><EditNote sx={{fontSize:'1.5rem', cursor:'pointer',margin:'5px'}}/></Button><Button variant="contained" color="warning" sx={{padding:'1px',margin:'5px'}} onClick={ () => handleOpenEditUserPasswordModal(row)}><Key sx={{fontSize:'1.5rem', cursor:'pointer',margin:'5px'}}/></Button></TableCell>
                                                        </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 50, 100]}
                                    component="div"
                                    count={totalUserItems} // Replace with the total number of items for the table
                                    rowsPerPage={userrowsPerPage}
                                    page={userpage}
                                    onPageChange={handleUserChangePage}
                                    onRowsPerPageChange={handleUserChangeRowsPerPage}
                                />

  <Modal
    open={addUserModal}
    onClose={handleCloseAddUserModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">New User</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseAddUserModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleAddUserSubmit}>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <TextField
                            fullWidth
                            select
                            label="Organization Name"
                            name="organization_id"
                            sx={{marginTop:"5px"}}
                            onChange={handleInputChange}
                            required="true">
                            <MenuItem value="" selected disabled>Select Organization</MenuItem>
                                  {organizationData.map((organization, i) => (
                                      <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                                  ))}
                          </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="User Name"
                        name="user_name"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="User Email"
                        name="user_email"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        type="email"
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="User Phone"
                        name="user_phone"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        type="tel"
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        select
                        label="User Level"
                        name="user_level"
                        sx={{marginTop:"5px"}}
                        onChange={handleInputChange}
                        required={true}
                    >
                        <MenuItem value="" disabled>Select Level</MenuItem>
                        <MenuItem value="admin">Admin</MenuItem>
                        <MenuItem value="agent">Agent</MenuItem>
                        <MenuItem value="supervisor">Supervisor</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="New User Password"
                        name="user_pass"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Add User</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>

<Modal
    open={editUserModal}
    onClose={handleCloseEditUserModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">Edit User | {selectedItem && (selectedItem.user_name)}</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseEditUserModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleEditUserSubmit}>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <TextField
                        label="User ID"
                        name="user_id"
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px",display:'none'}}
                        value={selectedItem.user_id || ''}
                    />
                                        <TextField
                            fullWidth
                            select
                            label="Organization Name"
                            name="organization_id"
                            sx={{marginTop:"5px"}}
                            onChange={handleInputModChange}
                            value={selectedItem.organization_id || ''}
                            required="true">
                            <MenuItem value="" selected disabled>Select Organization</MenuItem>
                                  {organizationData.map((organization, i) => (
                                      <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                                  ))}
                          </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="User Name"
                        name="user_name"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.user_name || ''}
                        
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="User Extension"
                        name="user_extension"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.user_extension || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="User Email"
                        name="user_email"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        type="email"
                        sx={{marginTop:"5px"}}
                        value={selectedItem.user_email || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="User Phone"
                        name="user_phone"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        type="tel"
                        sx={{marginTop:"5px"}}
                        value={selectedItem.user_phone || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        select
                        label="User Level"
                        name="user_level"
                        sx={{marginTop:"5px"}}
                        onChange={handleInputModChange}
                        required={true}
                        value={selectedItem.user_level || ''}
                    >
                        <MenuItem value="" disabled>Select Level</MenuItem>
                        <MenuItem value="admin">Admin</MenuItem>
                        <MenuItem value="agent">Agent</MenuItem>
                        <MenuItem value="supervisor">Supervisor</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={6}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Edit User</Button>
                </Grid>

                <Grid item xs={6}>
                    <Button type="button" variant="contained" color='error' sx={{padding:"10px",marginTop:"10px",width:"100%"}} onClick={()=>handleDeleteUser(selectedItem.user_id)}>Delete User</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>   

<Modal
    open={editUserPasswordModal}
    onClose={handleCloseEditUserPasswordModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">Update User Password | {selectedItem && (selectedItem.user_name)}</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseEditUserPasswordModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleEditUserPasswordSubmit}>
            <Grid container spacing={1}>

                <Grid item xs={12}>
                    <TextField
                        label="New User Password"
                        name="user_pass"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                    <TextField
                        name="user_id"
                        sx={{display:'none!important'}}
                        value={selectedItem.user_id || ''}
                    />
                </Grid>


                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color='warning' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Edit User Password</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>   
                                
                                </Box>)}
            {activeTab === 3 && (<Box>
                <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
                <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search"
        />
            <Button
    variant="contained"
    fullWidth
    type="submit"
    color='info'
    sx={{padding:'10px', }}
    onClick={handleOpenAddSmsModal}
  >Add SMS Settings
    </Button>

        </Box>
                    <TableContainer>
                                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                                        {/* Table Head */}
                                        <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                                            <TableRow>
                                                <TableCell>Organization</TableCell>
                                                <TableCell>Provider</TableCell>
                                                <TableCell>Endpoint</TableCell>
                                                <TableCell>Partner ID</TableCell>
                                                <TableCell>API Key</TableCell>
                                                <TableCell>Short Code</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {smsData
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{row.organization_name}</TableCell>
                                                        <TableCell>{row.provider}</TableCell>
                                                        <TableCell>{row.end_point}</TableCell>
                                                        <TableCell>{row.partner_id}</TableCell>
                                                        <TableCell>{row.api_key ? `${row.api_key.substring(0, 4)}...${row.api_key.slice(-4)}` : 'N/A'}</TableCell>
                                                        <TableCell>{row.short_code}</TableCell>
                                                        <TableCell><Button variant="contained" color="info" sx={{padding:'1px',margin:'5px'}} onClick={ () => handleOpenEditSmsModal(row)}><EditNote sx={{fontSize:'1.5rem', cursor:'pointer',margin:'5px'}}/></Button></TableCell>
                                                        </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 50, 100]}
                                    component="div"
                                    count={totalSmsItems} // Replace with the total number of items for the table
                                    rowsPerPage={smsrowsPerPage}
                                    page={smspage}
                                    onPageChange={handleSmsChangePage}
                                    onRowsPerPageChange={handleSmsChangeRowsPerPage}
                                />
                                
                                <Modal
    open={addSmsModal}
    onClose={handleCloseAddSmsModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">New SMS Configuration</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseAddSmsModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleAddSmsSubmit}>
            <Grid container spacing={1}>
            <Grid item xs={6}>

<TextField
                            fullWidth
                            select
                            label="Organization Name"
                            name="organization_id"
                            sx={{marginTop:"5px"}}
                            onChange={handleInputChange}
                            required="true">
                            <MenuItem value="" selected disabled>Select Organization</MenuItem>
                                  {organizationData.map((organization, i) => (
                                      <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                                  ))}
                          </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Provider"
                        name="provider"
                        sx={{marginTop:"5px"}}
                        onChange={handleInputChange}
                        required={true}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="End Point"
                        name="end_point"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="API Key"
                        name="api_key"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Partner ID"
                        name="partner_id"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Short Code"
                        name="short_code"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Add SMS Configuration</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>

<Modal
    open={editSmsModal}
    onClose={handleCloseEditSmsModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">Edit SMS Configuration | {selectedItem && (selectedItem.organization_name)}</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseEditSmsModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleEditSmsSubmit}>
            <Grid container spacing={1}>
                <Grid item xs={6}>

<TextField
                            fullWidth
                            select
                            label="Organization Name"
                            name="organization_id"
                            sx={{marginTop:"5px"}}
                            onChange={handleInputModChange}
                            value={selectedItem.organization_id || ''}
                            required="true">
                            <MenuItem value="" selected disabled>Select Organization</MenuItem>
                                  {organizationData.map((organization, i) => (
                                      <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                                  ))}
                          </TextField>
                </Grid>

                <Grid item xs={6}>
                <TextField
                        label="Provider"
                        name="provider"
                        onChange={handleInputModChange}
                        aria-readonly
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.provider|| ''}
                    />
                    <TextField
                        name="id"
                        required={true}
                        sx={{marginTop:"5px",display:'none!important'}}
                        value={selectedItem.id || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="End Point"
                        name="end_point"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.end_point || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="API Key"
                        name="api_key"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.api_key || ''}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Partner ID"
                        name="partner_id"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        sx={{marginTop:"5px"}}
                        value={selectedItem.partner_id || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Short Code"
                        name="short_code"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.short_code || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Edit SMS Configuration</Button>
                </Grid>

                <Grid item xs={6}>
                    <Button type="button" variant="contained" color='error' sx={{padding:"10px",marginTop:"10px",width:"100%"}} onClick={()=>handleDeleteSmsSettings(selectedItem.id)}>Delete SMS Configuration</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>                             
                                </Box>)}
            {activeTab === 4 && (<Box>
                <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
                <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search"
        />
            <Button
    variant="contained"
    fullWidth
    type="submit"
    color='info'
    sx={{padding:'10px', }}
    onClick={handleOpenAddEmailModal}
  >Add Email Settings
    </Button>



        </Box>
                    <TableContainer>
                                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                                        {/* Table Head */}
                                        <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                                            <TableRow>
                                                <TableCell>Organization</TableCell>
                                                <TableCell>Email</TableCell>
                                                <TableCell>SMTP Server</TableCell>
                                                <TableCell>SMTP Port</TableCell>
                                                <TableCell>IMAP Server</TableCell>
                                                <TableCell>IMAP Port</TableCell>
                                                <TableCell>Encryption</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {emailSettingsData
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{row.organization_name}</TableCell>
                                                        <TableCell>{row.user_name}</TableCell>
                                                        <TableCell>{row.smtp_server}</TableCell>
                                                        <TableCell>{row.smtp_port}</TableCell>
                                                        <TableCell>{row.imap_server}</TableCell>
                                                        <TableCell>{row.imap_port}</TableCell>
                                                        <TableCell>{row.encryption_type}</TableCell>
                                                        <TableCell><Button variant="contained" color="info" sx={{padding:'1px',margin:'5px'}} onClick={ () => handleOpenEditEmailModal(row)}><EditNote sx={{fontSize:'1.5rem', cursor:'pointer',margin:'5px'}}/></Button></TableCell>
                                                        </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 50, 100]}
                                    component="div"
                                    count={totalEmailItems} // Replace with the total number of items for the table
                                    rowsPerPage={emailContactrowsPerPage}
                                    page={emailContactpage}
                                    onPageChange={handleEmailContactChangePage}
                                    onRowsPerPageChange={handleEmailContactChangeRowsPerPage}
                                />

<Modal
    open={addEmailModal}
    onClose={handleCloseAddEmailModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">New Email Configuration</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseAddEmailModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleAddEmailSubmit}>
            <Grid container spacing={1}>
            <Grid item xs={6}>
            <TextField
                fullWidth
                select
                label="Organization Name"
                name="organization_id"
                sx={{marginTop:"5px"}}
                onChange={handleInputChange}
                required="true">
                <MenuItem value="" selected disabled>Select Organization</MenuItem>
                    {organizationData.map((organization, i) => (
                        <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                    ))}
                </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="User Name (Email)"
                        name="user_name"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="SMTP Server"
                        name="smtp_server"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="SMTP Port"
                        name="smtp_port"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        type="number"
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="IMAP Server"
                        name="imap_server"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="IMAP Port"
                        name="imap_port"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        type="number"
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Email Password"
                        name="email_password"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        select
                        label="Encryption Type"
                        name="encryption_type"
                        sx={{marginTop:"5px"}}
                        onChange={handleInputChange}
                        required={true}
                    >
                        <MenuItem value="" disabled>Select Encryption</MenuItem>
                        <MenuItem value="ssl">SSL</MenuItem>
                        <MenuItem value="tls">TLS</MenuItem>
                        <MenuItem value="none">None</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Add Email Configuration</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>

<Modal
    open={editEmailModal}
    onClose={handleCloseEditEmailModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">Edit Email Configuration | {selectedItem && (selectedItem.organization_name)}</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseEditEmailModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleEditEmailSubmit}>
            <Grid container spacing={1}>
            <Grid item xs={6}>
            <TextField
                fullWidth
                select
                label="Organization Name"
                name="organization_id"
                sx={{marginTop:"5px"}}
                onChange={handleInputModChange}
                value={selectedItem.organization_id || ''}
                required="true">
                <MenuItem value="" selected disabled>Select Organization</MenuItem>
                    {organizationData.map((organization, i) => (
                        <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                    ))}
                </TextField>
                <TextField
                        name="mail_id"
                        required={true}
                        sx={{marginTop:"5px",display:'none!important'}}
                        value={selectedItem.mail_id || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="User Name"
                        name="user_name"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.user_name || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="SMTP Server"
                        name="smtp_server"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.smtp_server || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="SMTP Port"
                        name="smtp_port"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        type="number"
                        sx={{marginTop:"5px"}}
                        value={selectedItem.smtp_port || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="IMAP Server"
                        name="imap_server"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        sx={{marginTop:"5px"}}
                        value={selectedItem.imap_server || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="IMAP Port"
                        name="imap_port"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        type="number"
                        sx={{marginTop:"5px"}}
                        value={selectedItem.imap_port || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Email Password"
                        name="email_password"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.email_password || ''}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        select
                        label="Encryption Type"
                        name="encryption_type"
                        sx={{marginTop:"5px"}}
                        onChange={handleInputModChange}
                        required={true}
                        value={selectedItem.encryption_type || ''}
                    >
                        <MenuItem value="" disabled>Select Encryption</MenuItem>
                        <MenuItem value="ssl">SSL</MenuItem>
                        <MenuItem value="tls">TLS</MenuItem>
                        <MenuItem value="none">None</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={6}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Edit Email Configuration</Button>
                </Grid>

                <Grid item xs={6}>
                    <Button type="button" variant="contained" color='error' sx={{padding:"10px",marginTop:"10px",width:"100%"}} onClick={()=>handleDeleteEmailSettings(selectedItem.mail_id)}>Delete Email Configuration</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>
</Box>)}
            {activeTab === 5 && (<Box>
                <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
                <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search"
        />
            <Button
    variant="contained"
    fullWidth
    type="submit"
    color='info'
    sx={{padding:'10px', }}
    onClick={handleOpenAddWhatsappModal}
  >Add WhatsApp Settings
    </Button>



        </Box>
                    <TableContainer>
                                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                                        {/* Table Head */}
                                        <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                                            <TableRow>
                                                <TableCell>Organization</TableCell>
                                                <TableCell>Business Name</TableCell>
                                                <TableCell>Phone ID</TableCell>
                                                <TableCell>Auth Bearer Token</TableCell>
                                                <TableCell>Verify Token</TableCell>
                                                <TableCell>Endpoint</TableCell>
                                                <TableCell>Type</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {whatsAppData
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{row.organization_name}</TableCell>
                                                        <TableCell>{row.business_name}</TableCell>
                                                        <TableCell>{row.phone_id}</TableCell>
                                                        <TableCell>{row.bearer ? `${row.bearer.substring(0, 4)}...${row.bearer.slice(-4)}` : 'N/A'}</TableCell>
                                                        <TableCell>{row.verify_token ? `${row.verify_token.substring(0, 4)}...${row.verify_token.slice(-4)}` : 'N/A'}</TableCell>
                                                        <TableCell>{row.end_point ? `${row.end_point.substring(0, 4)}...${row.end_point.slice(-4)}` : 'N/A'}</TableCell>
                                                        <TableCell>{row.type}</TableCell>
                                                        <TableCell><Button variant="contained" color="info" sx={{padding:'1px',margin:'5px'}} onClick={ () => handleOpenEditWhatsappModal(row)}><EditNote sx={{fontSize:'1.5rem', cursor:'pointer',margin:'5px'}}/></Button></TableCell>
                                                        </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 50, 100]}
                                    component="div"
                                    count={totalWhatsappItems} // Replace with the total number of items for the table
                                    rowsPerPage={whatsapprowsPerPage}
                                    page={whatsapppage}
                                    onPageChange={handleWhatsAppChangePage}
                                    onRowsPerPageChange={handleWhatsAppChangeRowsPerPage}
                                />
  <Modal
    open={addWhatsappModal}
    onClose={handleCloseAddWhatsappModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">New WhatsApp Configuration</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseAddWhatsappModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleAddWhatsappSubmit}>
            <Grid container spacing={1}>
        <Grid item xs={6}>
            <TextField
                fullWidth
                select
                label="Organization Name"
                name="organization_id"
                sx={{marginTop:"5px"}}
                onChange={handleInputChange}
                required="true">
                <MenuItem value="" selected disabled>Select Organization</MenuItem>
                    {organizationData.map((organization, i) => (
                        <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                    ))}
                </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Business Name"
                        name="business_name"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Phone ID"
                        name="phone_id"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Bearer Token"
                        name="bearer"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Verify Token"
                        name="verify_token"
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        sx={{marginTop:"5px"}}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        select
                        label="Type"
                        name="type"
                        sx={{marginTop:"5px"}}
                        onChange={handleInputChange}
                        required={true}
                    >
                        <MenuItem value="" disabled>Select Type</MenuItem>
                        <MenuItem value="system">System</MenuItem>
                        <MenuItem value="remote">Remote</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Add WhatsApp Configuration</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>

<Modal
    open={editWhatsappModal}
    onClose={handleCloseEditWhatsappModal}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
>
    <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">Edit WhatsApp Configuration | {selectedItem && (selectedItem.organization_name)}</h3>
            <Box display="flex" justifyContent="right">
                <Cancel onClick={handleCloseEditWhatsappModal} sx={{ cursor: 'pointer' }} />
            </Box>
        </Box>
        <form onSubmit={handleEditWhatsappSubmit}>
            <Grid container spacing={1}>
                
            <Grid item xs={6}>
            <TextField
                fullWidth
                select
                label="Organization Name"
                name="organization_id"
                sx={{marginTop:"5px"}}
                onChange={handleInputModChange}
                value={selectedItem.organization_id || ''}
                required="true">
                <MenuItem value="" selected disabled>Select Organization</MenuItem>
                    {organizationData.map((organization, i) => (
                        <MenuItem key={i} value={organization.organization_id}>{organization.organization_name}</MenuItem>
                    ))}
                </TextField>
                <TextField
                        name="unique_id"
                        required={true}
                        sx={{marginTop:"5px",display:'none!important'}}
                        value={selectedItem.unique_id || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Business Name"
                        name="business_name"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.business_name || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Phone ID"
                        name="phone_id"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.phone_id || ''}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Bearer Token"
                        name="bearer"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.bearer || ''}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Verify Token"
                        name="verify_token"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        sx={{marginTop:"5px"}}
                        value={selectedItem.verify_token || ''}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="End Point"
                        name="end_point"
                        onChange={handleInputModChange}
                        fullWidth
                        variant="outlined"
                        required={true}
                        sx={{marginTop:"5px"}}
                        value={selectedItem.end_point || ''}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        select
                        label="Type"
                        name="type"
                        sx={{marginTop:"5px"}}
                        onChange={handleInputModChange}
                        required={true}
                        value={selectedItem.type || ''}
                    >
                        <MenuItem value="" disabled>Select Type</MenuItem>
                        <MenuItem value="system">System</MenuItem>
                        <MenuItem value="remote">Remote</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={6}>
                    <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Edit WhatsApp Configuration</Button>
                </Grid>

                <Grid item xs={6}>
                    <Button type="button" variant="contained" color='error' sx={{padding:"10px",marginTop:"10px",width:"100%"}} onClick={()=> handleDeleteWhatsappConfigs(selectedItem.unique_id) }>Delete Configuration</Button>
                </Grid>
            </Grid>
        </form>
    </Box>
</Modal>                              
                                
                                </Box>)}
            {activeTab === 6 && (<Box> <Typography variant='h6' sx={{textAlign:'center', p:3}}>Coming Soon</Typography></Box>)}
            {activeTab === 7 && (<Box> <Typography variant='h6' sx={{textAlign:'center', p:3}}>Coming Soon</Typography></Box>)}
            {activeTab === 8 && (<Box> <Typography variant='h6' sx={{textAlign:'center', p:3}}>Coming Soon</Typography></Box>)}
            {activeTab === 9 && (<Box> <Typography variant='h6' sx={{textAlign:'center', p:3}}>In Progress</Typography></Box>)}
                </Box>
            </Grid>
        </Grid>
</>
    );
};

export default Settings;
